import './App.scss';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Navbar from './Shared/Navbar';
import Sidebar from './Shared/Sidebar';
import Footer from './Shared/Footer';
import {alertActions, authenticationActions} from './_redux/actions';
import {alertConstants, authenticationConst} from './_redux/constants';
import {Alert} from "react-bootstrap";
import {appRoutePath} from "./_helpers/AppConts";
import {getStoreLocal, getUserLocal, isAuthorized, isUserUnauthorized} from "./_helpers/HNTUtil";
import AppointmentBook from "./Appointment/AppointmentBook";
import Error500 from "./Error/Error500";


class App extends React.Component {
  state = {
    isAuthenticated: true,
    user: getUserLocal(),
    storeAccessed: getStoreLocal()
  }

  componentDidMount() {

    this.onRouteChanged();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.authRedu && nextProps.authRedu.type) {
      let type = nextProps.authRedu.type;

      if (type === authenticationConst.LOGOUT_SUCCESS) {
        if (this.state.user) {
          this.setState({
            user: null,
            storeAccessed: null,
            isAuthenticated: false
          });
        }

        console.log('componentWillReceiveProps', `type = ${type}`, 'Called!!!');
      }
      else if (type === authenticationConst.LOGIN_SUCCESS) {
        this.setState({
          user: getUserLocal(),
          storeAccessed: getStoreLocal(),
          isAuthenticated: isAuthorized()
        });
        console.log('componentWillReceiveProps', `type = ${type}`, 'Called!!!');
      }
      else if (type === authenticationConst.ACCESS_STORE_SUCCESS) {
        if (!this.state.storeAccessed) {
          this.setState({
            storeAccessed: getStoreLocal()
          });
        }

        console.log('componentWillReceiveProps', `type = ${type}`, 'Called!!!');
      }
      else if (type === authenticationConst.LEAVE_STORE_SUCCESS) {
        if (this.state.storeAccessed) {
          this.setState({
            storeAccessed: null
          });
        }

        console.log('componentWillReceiveProps', `type = ${type}`, 'Called!!!');
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.props.clearAlerts();
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    if (this.isAppointmentBookSite()) {
      return;
    }

    window.scrollTo(0, 0);
    const {location} = this.props;

    for ( let i = 0; i < fullPageLayoutRoutes.length; i++ ) {
      if (location && location.pathname === fullPageLayoutRoutes[i]) {
        this.setState({
          isFullPageLayout: true
        })
        document.querySelector('.page-body-wrapper').classList.add('full-page-wrapper');
        break;
      } else {
        this.setState({
          isFullPageLayout: false
        })
        document.querySelector('.page-body-wrapper').classList.remove('full-page-wrapper');
      }
    }
  }


  onLogout = () => {
    this.props.logout();
  }

  /**
   * Cheking whether the AppointmentBookSite
   */
  isAppointmentBookSite = () => {
    const location = this.props.location ? this.props.location : (this.props.location.location ? this.props.location.location : null);
    if (location && location.pathname) {
      try {
        return location.pathname.startsWith(appRoutePath.AppointmentBook);
      } catch (e) {
        return false;
      }
    }
    return false;
  }

  render () {
    /**If AppointmentBook*/
    if (this.isAppointmentBookSite()) {
      return (
          <div className="container-scroller">
            <div className="container-fluid page-body-wrapper">
              <AppointmentBook/>
            </div>
          </div>
      );
    }

    /**If Pages Admin*/
    let navbarComponent = !this.state.isFullPageLayout ? <Navbar onLogout={this.onLogout}/> : '';
    let sidebarComponent = !this.state.isFullPageLayout ? <Sidebar storeAccessed={this.state.storeAccessed}/> : '';
    let footerComponent = !this.state.isFullPageLayout ? <Footer/> : '';
    let {alert} = this.props;
    let variant = getVariantAlert(alert);

    return (
        <div className="container-scroller">
          { navbarComponent }
          <div className="container-fluid page-body-wrapper">
            { sidebarComponent }
            <div className="main-panel">
              {alert.message && <Alert variant={variant}>{alert.message}</Alert>}
              <div className="content-wrapper">
                <AppRoutes isAuthenticated={this.state.isAuthenticated}
                           user={this.state.user}
                           storeAccessed={this.state.storeAccessed}
                />
              </div>
              { footerComponent }
            </div>
          </div>
        </div>
    );
  }
}


const getVariantAlert = (alert) => {
  if (alert && alert.type) {
    return alert.type === alertConstants.ERROR ? 'danger' : 'success';
  }
  return alert && alert.message ? 'danger' : 'light';
}


const fullPageLayoutRoutes = [
  appRoutePath.LoginPage,
  appRoutePath.Error404,
  appRoutePath.Error500
];

function mapState(state) {
  const { alert, authRedu} = state;
  return { alert, authRedu};
}

const actionCreators = {
  clearAlerts: alertActions.clear,
  logout: authenticationActions.logout
};

const connectedApp = connect(mapState, actionCreators)(App);

export default withRouter(connectedApp);
